<template>
  <OverlayImageContainer v-if="carouselContext.isOverlayOpen" :altText="imageData.alt" :imageCredit="imageData.credit"
    :imageSrc="imageData.src" :title="imageData.title" :carouselContext="carouselContext" @open="onOpen"
    @close="onClose" @next="incrementIndex" @previous="decrementIndex" />
  <div v-else v-bind="{ [mountDataAttribute]: '' }">
  </div>
</template>
<script>
import OverlayImageContainer from "./overlay-image-container.vue";
import carouselNavigationMixins from "../collection/carousel/mixins.js"

export default {
  components: { OverlayImageContainer },
  props: {
    triggerEls: { type: Array, required: true },
    mountDataAttribute: { type: String, required: true, default: 'data-overlay-vue-container' },
    carouselContext: { type: Object, required: true }
  },
  mixins: [carouselNavigationMixins],
  data: function () {
    return {
      headerNavEl: document.querySelector('[data-nav]'),
      imageData: {
        alt: '',
        credit: '',
        src: '',
        title: ''
      },
    }
  },
  methods: {
    setImageData: function () {
      const { alt, dataset: { imageOverlayCredit: credit, imageOverlaySrc: src, imageOverlayTitle: title } } = this.triggerEls[this.carouselContext.index];
      if (this.carouselContext.isOverlayOpen) return Object.assign(this.imageData, { alt, credit, src, title });
      Object.assign(this.imageData, { alt: '', credit: '', src: '', title: '' });
    },
    returnFocusToTriggerEl: function (srcAttr) {
      if (srcAttr && document.querySelector('[data-image-overlay-src="' + srcAttr + '"]')) {
        document.querySelector('[data-image-overlay-src="' + srcAttr + '"]').focus();
      }
    },
    onOpen: function () {
      if (this.headerNavEl) this.headerNavEl.classList.add('headroom--frozen');
      window.MoMA.ScrollManager.preventScroll(document.querySelector("[data-overlay-content-container]"));
    },

    onClose: function () {
      this.returnFocusToTriggerEl(this.imageData.src)
      if (this.headerNavEl) this.headerNavEl.classList.remove("headroom--frozen");
      window.MoMA.ScrollManager.enableScroll();

      const onCloseTransitionEnd = (e) => {
        if (e.propertyName != 'opacity') return;
        this.$el.removeEventListener('transitionend', onCloseTransitionEnd);
        this.carouselContext.isOverlayOpen = false;
      }
      this.$el.addEventListener('transitionend', onCloseTransitionEnd);
    }
  },
  watch: {
    'carouselContext.index': function () {
      this.setImageData();
    },
    'carouselContext.isOverlayOpen': function () {
      this.setImageData();
    }
  }
};
</script>
